module.exports = __webpack_public_path__ + "img/719.1b8653d0.jpg";